export default __webpack_public_path__ + "images/7b81c4075b14263061c66b5721aa66fe-baby.webp";